__turbopack_context__.v({
  "bottomBorder": "PdfList-module-scss-module__6EdDtq__bottomBorder",
  "flex": "PdfList-module-scss-module__6EdDtq__flex",
  "item": "PdfList-module-scss-module__6EdDtq__item",
  "pdfList": "PdfList-module-scss-module__6EdDtq__pdfList",
  "topBorder": "PdfList-module-scss-module__6EdDtq__topBorder",
});
